import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { notifyParent } from 'mailup-react-helpers'

import {
  TruncateAndTooltip,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Text,
  TEXT_VARIANT_LIGHT,
  Flex
} from 'mailup-web-components'

const MessageCell = ({ title, idMessage, note, sender }) => {
  const intl = useIntl()

  const handleClick = () => {
    notifyParent('openPreviewMainFrame', [idMessage])
  }

  return (
    <Flex flexDirection='column' rowGap='8px' padding='24px 16px'>
      <Link
        onClick={handleClick}
        variant={LINK_VARIANT_HIGHLIGHT}
        data-mu-test='c-sendstatus-item__subject'
      >
        <TruncateAndTooltip
          text={title}
          tooltip={{
            text: `<strong>${intl.formatMessage({
              id: 'Load.Schedulation.lblFrom'
            })}:</strong> ${sender}`,
            force: true
          }}
        />
      </Link>
      <Text variant={TEXT_VARIANT_LIGHT}>
        <TruncateAndTooltip text={`${idMessage} ${note && `- ${note}`}`} />
      </Text>
    </Flex>
  )
}

export default MessageCell

MessageCell.propTypes = {
  title: PropTypes.any,
  note: PropTypes.any,
  sender: PropTypes.any,
  idMessage: PropTypes.number
}
